export default "/images/d6d308397cb596a1d0b600060dd6558d.avif";